<template>
    <button role="button" aria-label="Scroll to to of page" class="button" :onClick="scrollToTop"> {{ label }} </button>
</template>
  
<script setup>
const props = defineProps({
  label: {
    type: String,
    default: '',
  },
});

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
</script>
